var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconRepair(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "icon repair"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 40",
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 27",
    d: "M-187-183v-16.806l12.006-7.194 11.994 7.195V-183zm23 0v-16.239l-10.994-6.6-11.006 6.6V-183h2v-13a1 1 0 0 1 1-1h16a1 1 0 0 1 1 1v13zm-3 0v-9h-16v9zm0-10v-1h-16v1zm0-2v-1h-16v1zm-6.5-3.785a.385.385 0 0 1-.251-.112l-.956-.888.544-.544.956.888a.384.384 0 0 1 0 .544.381.381 0 0 1-.25.112zm-3.311-.091a.3.3 0 0 1 0-.425l2.26-2.26a.759.759 0 0 1 .176-.806.761.761 0 0 1 .806-.177l-.277.277a.3.3 0 0 0 0 .425.3.3 0 0 0 .425 0l.277-.277a.728.728 0 0 1 .04.155v.22a.768.768 0 0 1-.218.432.76.76 0 0 1-.806.177l-2.26 2.259a.3.3 0 0 1-.216.091.292.292 0 0 1-.208-.092zm.643-2.751-.163.15a.1.1 0 0 1-.136 0l-.412-.682a.1.1 0 0 1-.023-.06v-.008a.092.092 0 0 1 .028-.064l.272-.272a.1.1 0 0 1 .134 0l.681.41a.1.1 0 0 1 0 .136l-.151.179.493.5-.228.215z",
    transform: "translate(187 207)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Trac\\xE9 30",
    d: "M8.972 5.264a2.387 2.387 0 0 1 .756-1.745l-.713-1.1L7.3 4.794h.97a.3.3 0 0 1 .294.244A1.336 1.336 0 0 1 8.3 6.11a1.189 1.189 0 0 1-.929.36c-.058 0-.116 0-.178-.008a.3.3 0 0 1 .048-.6.721.721 0 0 0 .614-.156.565.565 0 0 0 .125-.318h-3.2A2.391 2.391 0 1 1 3.412 3.1l.951-1.372-.315-.5h-.366a.3.3 0 0 1 0-.6h1.847a.3.3 0 0 1 0 .6h-.776l.175.28h3.453L7.614.479A.3.3 0 0 1 7.854 0H9.71a.3.3 0 0 1 0 .6H8.452l.767 1.024a.3.3 0 0 1 .038.067l.956 1.477a2.393 2.393 0 1 1-1.24 2.1zm.6 0a1.8 1.8 0 1 0 .968-1.593l.815 1.259a.3.3 0 1 1-.5.325l-.795-1.222a1.789 1.789 0 0 0-.49 1.231zm-8.972 0a1.795 1.795 0 0 0 3.584.128H2.392a.3.3 0 0 1-.245-.469L3.064 3.6A1.794 1.794 0 0 0 .6 5.264zm5.68-.47L4.708 2.279l-.791 1.14a2.391 2.391 0 0 1 .822 1.374zm-3.314 0h1.159a1.8 1.8 0 0 0-.551-.88zm3.825-.312L8.506 2.1H5.3z",
    transform: "translate(5.121 16.344)",
    style: {
      fill: "#fff"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconRepair);
export default __webpack_public_path__ + "static/media/iconRepair.2873a1407a7b2d11616d640dd3c92ee9.svg";
export { ForwardRef as ReactComponent };